import { Box, Container, Typography, Divider, Grid, Paper } from '@mui/material';
import { FC } from 'react';
import DisplayField from '@acorn-portal/shared/src/components/displayField';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { PolicyCancelledWithDebt } from '@acorn-portal/shared/src/components/paymentDetails';

const CancelledPolicyOutstandingBalance: FC = () => {
	const payNow = useAppSelector((redux) => redux.payNow);

	const { details } = payNow;

	return (
		<Paper
			elevation={1}
			sx={{
				margin: 1.5,
				borderRadius: '8px',
				paddingBottom: 3,
			}}
		>
			<Container maxWidth='sm'>
				<Box sx={{ padding: 2 }} />
				<Typography variant='h4' component='h4' color='secondary' sx={{ textAlign: 'center' }}>
					Policy Cancelled
				</Typography>
				<Box sx={{ padding: 2 }} />
				<Box my={2}>
					<Grid container spacing={1}>
						<Grid size={{ xs: 10, md: 12 }}>
							<DisplayField label='Policy Holder'>
								{details?.policyHolderFirstName} {details?.policyHolderLastName}
							</DisplayField>
						</Grid>
						<Grid size={{ xs: 10, md: 12 }}>
							<DisplayField label='Policy Number'>{details?.policyReference}</DisplayField>
						</Grid>
					</Grid>
				</Box>
				<Divider sx={{ borderColor: 'rgb(109, 109, 109)' }} />
				<br />
				<PolicyCancelledWithDebt />
			</Container>
		</Paper>
	);
};
export default CancelledPolicyOutstandingBalance;
